import { useState } from "react";
import { AiFillFilePdf, AiFillVideoCamera, AiTwotoneCamera } from "react-icons/ai";
import { uploadAccept, validateUploadFile } from "../utilities/importantFns";


export const MediaUploadInput = ({handleUpload, onChangeFn, onClick, className, videoNull, pdfNull}:any) => {

    const [feedBack, setFeedBack] = useState("")
    const [fileNames, setFileNames] = useState(["", "", ""]);

    const txt1 = `Image${!pdfNull ? ", and PDF" : ""} file size should not exceed 9MB`

    return (
        <div className={className || "w-2/3 pl-6 flex flex-col"}>
            <div className="flex items-center w-full">
                <label className="picCap mr-4">
                    <AiTwotoneCamera className="picIcon" />
                    <p>Photo</p>
                    <input type="file"
                        onChange={(e : any)=> {
                            setFeedBack("")
                            const file = e.target.files?.[0];

                            if (!file) return;

                            const validation = validateUploadFile(file, "image");
                            if (!validation.valid) {
                                setFeedBack(validation.message);
                                e.target.value = "";
                                return;
                            }

                            if(file.size >= 10000000){
                                setFeedBack("You can only upload an image file of less than 9MB");
                                e.target.value = "";
                                return
                            }else{
                                setFileNames((prev)=> {
                                    const next = [...prev];
                                    next[0] = file.name;
                                    return next;
                                });
                                onChangeFn(e, "image")
                            }

                        }}
                        className="hidden"
                        name="photoUpload"
                        accept={uploadAccept.image}
                    />
                </label>
               {!videoNull &&
               (<label className="picCap mr-4">
                    <AiFillVideoCamera className="picIcon" />
                    <p>Video</p>
                    <input type="file"
                        onChange={(e : any)=> {
                            setFeedBack("")
                            const file = e.target.files?.[0];

                            if (!file) return;

                            const validation = validateUploadFile(file, "video");
                            if (!validation.valid) {
                                setFeedBack(validation.message);
                                e.target.value = "";
                                return;
                            }

                            if(file.size >= 100000000){
                                setFeedBack("You can only upload a video file of less than 95MB");
                                e.target.value = "";
                                return
                            }else{
                                setFileNames((prev)=> {
                                    const next = [...prev];
                                    next[1] = file.name;
                                    return next;
                                });
                                onChangeFn(e, "video")
                            }

                        }}
                        className="hidden"
                        name="videoUpload"
                        accept={uploadAccept.video}
                    />
                </label>)
                }

                {!pdfNull &&
                (<label className="picCap">
                    <AiFillFilePdf className="picIcon" />
                    <p>Doc</p>
                    <input type="file"
                        onChange={(e: any)=> {
                            setFeedBack("")
                            const file = e.target.files?.[0];

                            if (!file) return;

                            const validation = validateUploadFile(file, "document");
                            if (!validation.valid) {
                                setFeedBack(validation.message);
                                e.target.value = "";
                                return
                            }else if(file.size >= 10000000){
                                setFeedBack("You can only upload a document file of less than 9MB");
                                e.target.value = "";
                                return
                            }else{
                                setFileNames((prev)=> {
                                    const next = [...prev];
                                    next[2] = file.name;
                                    return next;
                                });
                                onChangeFn(e, "doc")
                            }

                        }}
                        className="hidden"
                        name="doc"
                        accept={uploadAccept.document}
                    />
                </label>)
                }
                {fileNames[0].length>0 || fileNames[1].length>0 && <button onClick={()=>{ setFileNames(["", ""]); onChangeFn(null, "image"); onChangeFn(null, "video")}} className="ml-2 underline text-sm text-red-500">clear</button>}
            </div>

            {fileNames && <div className="text-[10px] w-full mt-1">
            {fileNames.map((fileName,idx)=> <p key={idx}>{fileName}</p>)}
            </div>}

            {feedBack && <p className="w-full my-3 text-red-800 sm:text-xs ">{feedBack}</p>}

            <p className="w-full my-5 text-red-800 sm:text-xs">
                <b>⚠️</b> {txt1}
                <br />
                ⚠️Video file size should not exceed 95MB
                </p>


        </div>
    )
}
